<template>
  <vs-table search stripe max-items="10" pagination :data="registros">
    <template slot="header">
      <h5>REGISTROS:</h5>
    </template>
    <template slot="thead">
      <vs-th>Código</vs-th>
      <vs-th>Tipo</vs-th>
      <vs-th>Tipo Item</vs-th>
      <vs-th>Categoría</vs-th>
      <vs-th>Nombre</vs-th>
      <vs-th>Descripción</vs-th>
      <vs-th>Marca</vs-th>
      <vs-th>Cant. Vendida</vs-th>
    </template>
    <template slot-scope="{data}">
      <vs-tr :key="indextr" v-for="(tr, indextr) in data">
        <vs-td>{{ data[indextr].codigo }}</vs-td>
        <vs-td>{{ data[indextr].descripcion_tipo_item }}</vs-td>
        <vs-td>{{ data[indextr].descripcion_tipo }}</vs-td>
        <vs-td>{{ data[indextr].descripcion_categoria?data[indextr].descripcion_categoria:'-' }}</vs-td>
        <vs-td>{{ data[indextr].nombre }}</vs-td>
        <vs-td>{{ data[indextr].descripcion }}</vs-td>
        <vs-td>{{ data[indextr].descripcion_marca?data[indextr].descripcion_marca:'-' }}</vs-td>
        <vs-td>{{ round3(data[indextr].cantidad_vendida, 2) }}</vs-td>
      </vs-tr>
    </template>
  </vs-table>
</template>

<script>
export default {
  props: {
    registros: {
      required: true
    }
  },
  data: function(){
    return {
      round3: round3
    }
  }
}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/forms/reportes/TablaMasVendidos.vue